"use strict";

exports.__esModule = true;
exports.TextCellType = exports.CELL_TYPE = void 0;
var _textType = require("./textType");
exports.CELL_TYPE = _textType.CELL_TYPE;
exports.TextCellType = _textType.TextCellType;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/cellTypes/textType/index.js
// module id = 429
// module chunks = 0